import React from "react"
import { useThePoolz } from "@poolzfinance/reacthelper"

const BLOCKPASS_ID = "blockpass-kyc-connect"
interface IProps extends React.ComponentProps<"button"> {}

export default function VerifyButton({ children, ...props }: IProps) {
  const [isLoaded, setIsLoaded] = React.useState(false)
  const thePoolz = useThePoolz()
  const { account } = thePoolz

  React.useEffect(() => {
    const ID_SCRIPT = BLOCKPASS_ID + "-script"
    const findExist = document.getElementById(ID_SCRIPT)
    if (findExist) return findExist.remove()

    const script = document.createElement("script")
    script.src = import.meta.env.VITE_APP_KYC_WIDGET_SRC
    script.async = true
    script.id = ID_SCRIPT
    script.dataset.testid = ID_SCRIPT
    script.onload = () => {
      const blockpass = new window.BlockpassKYCConnect(import.meta.env.VITE_APP_KYC_CLIENT_ID, {
        refId: account ?? ""
      })
      blockpass.startKYCConnect()
      // .on("KYCConnectCancel", () => {})
      // .on("KYCConnectSuccess", () => {})
      setIsLoaded(true)
    }
    document.body.appendChild(script)
  }, [account])

  return (
    <button id={BLOCKPASS_ID} disabled={!isLoaded} {...props}>
      {children}
    </button>
  )
}
